import * as SearchActions from '../../state/search/search.action';

import template from './alerts-btn-group.template.html';

export class AlertsBtnGroupController {
  constructor($ngRedux) {
    'ngInject';

    this.store = $ngRedux;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    const { alerts } = state.search;
    return { alerts };
  }

  updateAlertFacet(option) {
    if (option._selected) {
      this.selectFacet(SearchActions.ALERTS_FACET_TYPE, option);
    } else {
      this.deselectFacet(SearchActions.ALERTS_FACET_TYPE, option);
    }
  }
}

export const AlertsBtnGroupComponent = {
  template,
  bindings: {},
  controller: 'AlertsBtnGroupController as vm'
};
